module.exports = __webpack_public_path__ + "media/customizations/harvestgreen/logo-5056f3f60e31341db29cc7d25f8d322b.png";